"use client";

import { useState } from "react";
import LogFilters from "./components/LogFilters";
import LogTable from "./components/LogTable";

export default function LogPage() {
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    tokenName: "",
    tokenGroup: "",
    logType: "",
    model: "",
    minUseTime: "",
    stream: "",
    ip: "",
    recentCount: 200,
  });
  const [refreshCount, setRefreshCount] = useState(0);

  const handleSearch = (newFilters: typeof filters) => {
    setFilters(newFilters);
  };

  const handleReset = () => {
    setFilters({
      startDate: "",
      endDate: "",
      tokenName: "",
      tokenGroup: "",
      logType: "",
      model: "",
      minUseTime: "",
      stream: "",
      ip: "",
      recentCount: 200,
    });
  };

  const handleRefresh = () => {
    setRefreshCount(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-background p-4 md:p-6 space-y-4">
      <LogFilters onSearch={handleSearch} onReset={handleReset} />
      <LogTable
        filters={filters}
        refreshCount={refreshCount}
        onRefresh={handleRefresh}
        selectedGroup={null}
      />
    </div>
  );
}
